module.exports = __webpack_public_path__ + "static/media/iym.afbe6c2c.png";